import Vue from 'vue'
import XRSearchHead  from './searchHead'

export default XRSearchHead




// WEBPACK FOOTER //
// ./src/components/usercenter/searchHead/index.js